import { CONFIG } from "~/constants/config"
import { Core } from "~/core/Core"
import { MenuTree } from "~/types/menu"

const prefix = "/marketing"

export const MenuMarketing: MenuTree = {
  home: {
    name: "Dashboard",
    icon: "mdi-view-dashboard",
    order: 0,
    to: prefix,
    permission_key: "home_dashboard",
  },

  customer: {
    name: "Customers",
    icon: "mdi-account",
    // to: prefix + "/customers",
    group: prefix + "/customers",
    order: 1,
    isChild: true,
    children: {
      customers: {
        name: "All Customers",
        icon: "mdi-account-group",
        to: prefix + "/customers",
        permission_key: "customer_all-customers",
      },
      linked_customers: {
        name: "Linked Customers",
        icon: "mdi-link-variant",
        to: prefix + "/customers/linked",
        permission_key: "customer_linked-customers",
      },
      databases: {
        name: "Customer Databases",
        icon: "mdi-database",
        to: prefix + "/customers/database",
        permission_key: "customer_customer-databases",
      },
      import: {
        name: "Import",
        icon: "mdi-account-arrow-left",
        to: prefix + "/customers/import",
        permission_key: "customer_import",
      },
      events: {
        name: "Events",
        icon: "mdi-shoe-print",
        to: prefix + "/customers/events",
        permission_key: "customer_events",
      },
    },
  },
  create_customer: {
    name: "Create Customer",
    icon: "mdi-account",
    isHide: true,
  },
  edit_customer: {
    name: "Edit Customer",
    icon: "mdi-account",
    isHide: true,
  },
  import_customer: {
    name: "Import Customers",
    icon: "mdi-account",
    to: prefix + "/customers/import",
    isHide: true,
  },
  tag_customer: {
    name: "Customers Tags",
    icon: "mdi-account",
    to: prefix + "/customers/tags",
    isHide: true,
  },
  attribute_customer: {
    name: "Customer Attributes",
    icon: "mdi-account",
    to: prefix + "/customers/attributes",
    isHide: true,
  },
  customer_databases: {
    name: "Customer Databases",
    icon: "mdi-database",
    to: prefix + "/customers/database",
    isHide: true,
  },
  create_customer_database: {
    name: "Create Customer Database",
    icon: "mdi-database",
    to: prefix + "/customers/database/create",
    isHide: true,
  },
  edit_customer_database: {
    name: "Edit Customer Database",
    icon: "mdi-database",
    isHide: true,
  },
  edit_customer_database_demographic: {
    name: "Edit Customer Demographic",
    icon: "mdi-database",
    isHide: true,
  },

  master_data: {
    name: "Master Data",
    icon: "mdi-database-sync",
    group: prefix + "/master-data",
    order: 9,
    isChild: true,
    children: {
      master_data: {
        name: "All Data",
        icon: "mdi-file-table-box-multiple",
        to: prefix + "/master-data",
        permission_key: "master-data_all-data",
      },
      master_data_databases: {
        name: "Master Data Databases",
        icon: "mdi-database",
        to: prefix + "/master-data/database",
        permission_key: "master-data_master-data-databases",
      },
      import: {
        name: "Import",
        icon: "mdi-database-arrow-left",
        to: prefix + "/master-data/import",
        permission_key: "master-data_import",
      },
    },
  },
  create_master_data: {
    name: "Create Master Data",
    icon: "mdi-databese-sync",
    isHide: true,
  },
  edit_master_data: {
    name: "Edit Master Data",
    icon: "mdi-account",
    isHide: true,
  },
  import_master_data: {
    name: "Import Master Data",
    icon: "mdi-account",
    to: prefix + "/master-data/import",
    isHide: true,
  },
  tag_master_data: {
    name: "Master Data Tags",
    icon: "mdi-account",
    to: prefix + "/master-data/tags",
    isHide: true,
  },
  attribute_master_data: {
    name: "Master Data Attributes",
    icon: "mdi-account",
    to: prefix + "/master-data/attributes",
    isHide: true,
  },
  master_data_databases: {
    name: "Customer Databases",
    icon: "mdi-database",
    to: prefix + "/master-data/database",
    isHide: true,
  },
  create_master_data_database: {
    name: "Create Customer Database",
    icon: "mdi-database",
    to: prefix + "/master-data/database/create",
    isHide: true,
  },
  edit_master_data_database: {
    name: "Master Data Database",
    icon: "mdi-database",
    isHide: true,
  },
  // edit_customer_database_demographic: {
  //   name: "Edit Customer Demographic",
  //   icon: "mdi-database",
  //   isHide: true,
  // },

  import: {
    name: "Data In/Out",
    icon: "mdi-file-import",
    to: prefix + "/migration",
    group: prefix + "/migration",

    order: 3,
    isChild: true,
    children: {
      import_demographic: {
        name: "Import Demographic",
        icon: "mdi-account-arrow-left",
        to: prefix + "/migration/demographic",
        permission_key: "data-in-out_import-demographic",
      },
      import_tracker: {
        name: "Import Tracker",
        icon: "mdi-shoe-print",
        to: prefix + "/migration/tracker",
        permission_key: "data-in-out_import-tracker",
      },
      import_consent_permission: {
        name: "Import Consent",
        icon: "mdi-shield-plus",
        to: prefix + "/migration/consent",
        permission_key: "data-in-out_import-consent",
      },
      data_flow: {
        name: "Data Flow",
        icon: "mdi-connection",
        to: prefix + "/migration/data-flow",
        permission_key: "data-in-out_data-flow",
      },
      data_flow_log: {
        name: "Data Flow Logs",
        icon: "mdi-file-eye",
        to: prefix + "/migration/data-flow-logs",
        permission_key: "data-in-out_data-flow-logs",
      }
    },
  },
  import_demographic: {
    name: "Import Demographic",
    icon: "mdi-account-arrow-left",
    to: prefix + "/migration/demographic",
    isHide: true,
  },
  import_tracker: {
    name: "Import Tracker",
    icon: "mdi-shoe-print",
    to: prefix + "/migration/tracker",
    isHide: true,
  },
  import_consent_permission: {
    name: "Import Consent Permission",
    icon: "mdi-shield-plus",
    to: prefix + "/migration/consent",
    isHide: true,
  },
  data_flow: {
    name: "Data Flow",
    icon: "mdi-connection",
    to: prefix + "/migration/data-flow",
    isHide: true,
  },
  edit_data_flow: {
    name: "Edit Data Flow",
    icon: "mdi-connection",
    isHide: true,
  },
  data_flow_logs: {
    name: "Data Flow Logs",
    icon: "mdi-file-eye",
    isHide: true,
  },

  segment: {
    name: "Segments",
    icon: "mdi-chart-pie",
    order: 3,
    to: prefix + "/segments",
    permission_key: "segments_segments",
  },
  create_segment: {
    name: "Create Segments",
    icon: "mdi-chart-pie",
    isHide: true,
  },
  edit_segment: {
    name: "Edit Segments",
    icon: "mdi-chart-pie",
    isHide: true,
  },
  segment_insight: {
    name: "Segment Insight",
    icon: "mdi-chart-pie",
    isHide: true,
  },

  campaign: {
    name: "Campaign",
    icon: "mdi-flag",
    order: 4,
    group: prefix + "/campaigns",
    isChild: true,
    children: {
      create_new: {
        icon: "mdi-clipboard-text-multiple-outline",
        name: "Campaigns List",
        to: prefix + "/campaigns",
        permission_key: "campaign_campaigns-list",
      },
      customer_journey: {
        name: "Customer Journeys",
        icon: "mdi-layers-triple",
        to: prefix + "/customer-journey",
        permission_key: "campaign_customer-journeys",
      },
    },
  },

  line: {
    name: "Line",
    icon: "mdi-alpha-l-box",
    order: 3,
    permission_key: "line_line",
    to: prefix + "/line/rich-menu",
  },
  whatsapp: {
    name: "WhatsApp",
    icon: "mdi-whatsapp",
    order: 3,
    to: prefix + "/whatsapp",
    permission_key: "whatsapp_whatsapp",
    isHide: !CONFIG.ENABLED_FEATURE_WHATSAPP,
  },
  create_campaign: {
    name: "Create Campaign",
    icon: "mdi-flag",
    isHide: true,
  },
  edit_campaign: {
    name: "Edit Campaign",
    icon: "mdi-flag",
    isHide: true,
  },
  insight_campaign: {
    name: "Insight Campaign",
    icon: "mdi-flag",
    isHide: true,
  },
  create_customer_journey: {
    name: "Create Customer Journey",
    icon: "mdi-layers-triple",
    isHide: true,
  },
  edit_customer_journey: {
    name: "Edit Customer Journey",
    icon: "mdi-layers-triple",
    isHide: true,
  },
  insights_customer_journey: {
    name: "Customer Journey Insight",
    icon: "mdi-layers-triple",
    isHide: true,
  },
  // consents: {
  //   name: "Consent Message",
  //   icon: "mdi-shield-account",
  //   to: prefix + "/consents/consent-message",
  //   permission_key: "pdpa_consent-message",
  //   order: 6,
  // },
  create_consent_message: {
    name: "Create Consent Message",
    icon: "mdi-shield-account",
    to: prefix + "/consent/consent-message/create",
    isHide: true,
  },
  edit_consent_message: {
    name: "Edit Consent Message",
    icon: "mdi-shield-account",
    isHide: true,
  },
  version_history_consent_message: {
    name: "Consent Message Version History",
    icon: "mdi-history",
    isHide: true,
  },
  history_detail_consent_message: {
    name: "Consent Message History Detail",
    icon: "mdi-history",
    isHide: true,
  },

  visualizations: {
    name: "Visualizations",
    icon: "mdi-chart-bar",
    to: prefix + "/visualizations/segments-funnel",
    isHide: !CONFIG.ENABLED_FEATURE_VISUALIZATIONS_FUNNELS,

    order: 7,
    group: prefix + "/visualizations",
    isChild: true,
    children: {
      segments_funnel: {
        name: "Segments Funnel",
        icon: "mdi-chart-sankey-variant",
        to: prefix + "/visualizations/segments-funnel",
        permission_key: "visualizations_segments-funnel",
      },
      dynamic_report: {
        name: "Dynamic Report",
        icon: "mdi-file-chart",
        to: prefix + "/visualizations/dynamic-report",
        permission_key: "visualizations_dynamic-report",
      },
    },
  },

  agent: {
    name: "AI Agents",
    icon: "mdi-robot",
    to: prefix + "/agents",
    permission_key: "ai-agents_ai-agents",
    order: 5,
  },
  create_agent: {
    name: "Create AI Agent",
    icon: "mdi-robot",
    isHide: true,
  },
  edit_agent: {
    name: "Edit AI Agent",
    icon: "mdi-robot",
    isHide: true,
  },

  segments_funnel: {
    name: "Segments Funnel",
    icon: "mdi-chart-sankey-variant",
    to: prefix + "/visualizations/segments-funnel",
    isHide: true,
  },
  create_segments_funnel: {
    name: "Create Funnel",
    icon: "mdi-chart-sankey-variant",
    isHide: true,
  },
  edit_segments_funnel: {
    name: "Edit Funnel",
    icon: "mdi-chart-sankey-variant",
    isHide: true,
  },
  dynamic_report: {
    name: "Dynamic Report",
    icon: "mdi-file-chart",
    to: prefix + "/visualizations/dynamic-report",
    isHide: true,
  },
  create_dynamic_report: {
    name: "Create Dynamic Report",
    icon: "mdi-file-chart",
    isHide: true,
  },
  create_dashboard: {
    name: "Create Dashboard",
    icon: "mdi-file-chart",
    isHide: true,
  },
  edit_dynamic_report: {
    name: "Edit Dynamic Report",
    icon: "mdi-file-chart",
    isHide: true,
  },

  affiliate: {
    name: "Affiliate",
    icon: "mdi-account-voice",
    isHide: !CONFIG.ENABLED_FEATURE_AFFILIATE,
    to: prefix + "/affiliates",
    permission_key: "affiliate_affiliate",
    order: 8,
  },

  landingpage: {
    name: "Landing Page",
    icon: "mdi-location-enter",
    isHide: !CONFIG.ENABLED_FEATURE_LANDINGPAGE,

    to: prefix + "/landingpages",
    group: prefix + "/landingpages",
    order: 8,
    isChild: true,
    children: {
      landingpage_landingpage: {
        name: "Landing Page",
        icon: "mdi-location-enter",
        to: prefix + "/landingpages",
        permission_key: "landing-page_landing-page",
      },
      landingpage_theme: {
        name: "Theme",
        icon: "mdi-palette",
        to: prefix + "/landingpages/themes",
        permission_key: "landing-page_theme",
      },
    },
  },
  landingpage_landingpage: {
    name: "Landing Page",
    icon: "mdi-location-enter",
    to: prefix + "/landingpages",
    isHide: true,
  },
  landingpage_theme: {
    name: "Landing Page Theme",
    icon: "mdi-palette",
    to: prefix + "/landingpages/themes",
    isHide: true,
  },
  create_landingpage_theme: {
    name: "Landing Page Theme",
    icon: "mdi-palette",
    isHide: true,
  },

  email_templates: {
    name: "Email Templates",
    icon: "mdi-email",
    to: prefix + "/email/templates",
    isHide: true,
  },
  create_email_template: {
    name: "Create Email Template",
    icon: "mdi-email",
    isHide: true,
  },
  edit_email_template: {
    name: "Edit Email Template",
    icon: "mdi-email",
    isHide: true,
  },
  attention_templates: {
    name: "Attention Templates",
    icon: "mdi-application",
    to: prefix + "/attention/templates",
    isHide: true,
  },
  create_attention_template: {
    name: "Create Attention Template",
    icon: "mdi-application",
    isHide: true,
  },
  edit_attention_template: {
    name: "Edit Attention Template",
    icon: "mdi-application",
    isHide: true,
  },
  roles: {
    name: "Roles",
    icon: "mdi-account-lock",
    to: prefix + "/roles",
    isHide: true,
  },
  external_users: {
    name: "External Users",
    icon: "mdi-account-multiple-outline",
    to: prefix + "/external-users",
    isHide: true,
  },
  external_roles: {
    name: "External Roles",
    icon: "mdi-account-key-outline",
    to: prefix + "/external-roles",
    isHide: true,
  },
  create_role: {
    name: "Create Role",
    icon: "mdi-account-lock",
    isHide: true,
  },
  edit_role: {
    name: "Edit Role",
    icon: "mdi-account-lock",
    isHide: true,
  },
  edit_permission: {
    name: "Edit Permission",
    icon: "mdi-account-lock",
    isHide: true,
  },
  create_external_role: {
    name: "Create External Role",
    icon: "mdi-account-key-outline",
    isHide: true,
  },
  edit_external_role: {
    name: "Edit External Role",
    icon: "mdi-account-key-outline",
    isHide: true,
  },
  general_setting: {
    name: "General",
    icon: "mdi-shield-account",
    isHide: true,
  },
  domain_setting: {
    name: "Domain",
    icon: "mdi-shield-account",
    isHide: true,
  },
  tool: {
    name: "More Tools",
    icon: "mdi-menu",
    group: prefix + "/tools",
    order: 10,
    isChild: true,
    expands: {
      users: {
        name: "Users",
        icon: "mdi-account-tie",
        to: prefix + "/users",
        permission_key: "tool_users",
      },
      external_users: {
        name: "External Users",
        icon: "mdi-account-multiple-outline",
        to: prefix + "/external-users",
        permission_key: "tool_external-users",
      },
      templates: {
        name: "Email Templates",
        icon: "mdi-email",
        to: prefix + "/email/templates",
        permission_key: "tool_templates",
      },
      attention_templates: {
        name: "Attention Templates",
        icon: "mdi-application",
        to: prefix + "/attention/templates",
        permission_key: "tool_attention-templates",
      },
      event_parameters: {
        name: "Events",
        icon: "mdi-table-arrow-left",
        to: prefix + "/events",
        permission_key: "tool_events",
      },
      master_language: {
        name: "Language",
        icon: "mdi-web",
        to: prefix + "/master/languages",
        permission_key: "tool_languages",
      },
      roles: {
        name: "Roles",
        icon: "mdi-account-lock",
        to: prefix + "/roles",
        permission_key: "tool_roles",
      },
      external_roles: {
        name: "External Roles",
        icon: "mdi-account-key-outline",
        to: prefix + "/external-roles",
        permission_key: "tool_external-roles",
      },
      external_api: {
        name: "External API",
        icon: "mdi-application-cog",
        to: prefix + "/external-api",
        permission_key: "tool_external-api",
      },
      script_gallery: {
        name: "Query Plugin",
        icon: "mdi-toy-brick-plus",
        to: prefix + "/script-gallery",
        permission_key: "tool_query-plugin",
      },
      data_plugin: {
        name: "Data Plugin",
        icon: "mdi-toy-brick-plus-outline",
        to: prefix + "/data-plugins",
        permission_key: "tool_data-plugin",
      },
      document: {
        name: "Document",
        icon: "mdi-file-document-outline",
        to: prefix + "/docs?collection=program-documentation",
        target: "_blank",
      },
      tasks: {
        name: "Tasks Viewer",
        icon: "mdi-magnify-expand",
        to: prefix + "/tasks",
        permission_key: "tool_tasks",
      },
      tasks_graph: {
        name: "Tasks Graph",
        icon: "mdi-chart-timeline",
        to: prefix + "/tasks-graph",
        permission_key: "tool_tasks-graph",
      },
      caches: {
        name: "Caches Viewer",
        icon: "mdi-cube-scan",
        to: prefix + "/caches",
        permission_key: "tool_caches",
      },
      metrics: {
        name: "Metrics",
        icon: "mdi-chart-line",
        to: Core.config.ENABLED_FEATURE_SHOW_METRICS_WITH_CLIENT
          ? prefix + `/metrics/${Core.config.METRIC_CLIENT_ADMIN}`
          : prefix + "/metrics",
        permission_key: "tool_metrics",
      },
      pamtag: {
        name: "Tracking Script",
        icon: "mdi-file-code",
        to: prefix + "/pamtag",
        permission_key: "tool_tracking-script",
      },
      settings: {
        name: "Settings",
        icon: "mdi-cog",
        to: prefix + "/settings",
        permission_key: "tool_settings",
      },
      agent_model: {
        name: "Agent Model",
        icon: "mdi mdi-shape-plus",
        to: prefix + "/agent-models",
        permission_key: "tool_agent-model",
      },
      consents: {
        name: "Consent Message",
        icon: "mdi-shield-account",
        to: prefix + "/consents/consent-message",
        permission_key: "pdpa_consent-message",
        order: 6,
      },
    },
  },
  create_external_api: {
    name: "Create External API",
    icon: "mdi-application-cog",
    isHide: true,
  },
  edit_external_api: {
    name: "Edit External API",
    icon: "mdi-application-cog",
    isHide: true,
  },
  create_affiliate: {
    name: "Create Affiliate",
    icon: "mdi-account-tie",
    isHide: true,
  },
  edit_affiliate: {
    name: "Edit Affiliate URL",
    icon: "mdi-account-tie",
    isHide: true,
  },
  create_personalize_shorten_url: {
    name: "Create Personalize Shprten URL",
    icon: "mdi-application-cog",
    isHide: true,
  },
  edit_personalize_shorten_url: {
    name: "Edit Personalize Shorten URL",
    icon: "mdi-application-cog",
    isHide: true,
  },
  create_landingpage: {
    name: "Create Landing Page",
    icon: "mdi-account-tie",
    isHide: true,
  },
  edit_landingpage: {
    name: "Edit Landing Page",
    icon: "mdi-account-tie",
    isHide: true,
  },
  create_script_gallery: {
    name: "Create Script",
    icon: "mdi-toy-brick-plus",
    isHide: true,
  },
  edit_script_gallery: {
    name: "Edit Plugin",
    icon: "mdi-toy-brick-plus",
    isHide: true,
  },
  view_task: {
    name: "View Task",
    icon: "mdi-magnify-expand",
    isHide: true,
  },

  // suits: {
  //   name: "Suits",
  //   icon: "mdi-arrow-right-bold",
  //   to: prefix + "",
  //   group: prefix + "",
  //   order: 1,
  //   children: {
  //     cdp: {
  //       name: "CDP",
  //       icon: "",
  //       to: prefix + "/",
  //     },
  //     crm: {
  //       name: "CRM",
  //       icon: "",
  //       to: prefix + "/",
  //     },
  //     chat_center: {
  //       name: "Chat Center",
  //       icon: "",
  //       to: prefix + "/",
  //     },
  //     survey: {
  //       name: "Survey",
  //       icon: "",
  //       to: CONFIG.PLATFORM_SURVEY,
  //     },
  //   },
  // },
}
